import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Tooltip } from "@tql/ui-components-react/kendo/tooltip";
import { infoCircle } from "@tql/ui-components-react/untitled/icons";

import styles from "./trax-info.module.css";

type TraxInfoProps = {
	tooltip: string;
};

export const TraxInfo = ({ tooltip }: TraxInfoProps) => {
	return (
		<span className={styles.traxInfoWrapper}>
			<Tooltip anchorElement={"target"} parentTitle={true} position={"top"}>
				<span title={tooltip}>
					<SvgIcon
						className={styles.traxInfo}
						icon={infoCircle}
						size={"small"}
					/>
				</span>
			</Tooltip>
		</span>
	);
};
